import _ from 'lodash'
import {slugify} from '@/common/helpers'
import {MEDIA_URL} from "@/common/config";

const mixins = {
    computed: {
        getEnv(){
            return process.env.VUE_APP_ENV;
        },
        brandColor(){
            switch(this.$store.state.settings.brand){
                case 'mustang':
                    return 'is-color-orange';
                case 'manitou':
                    return 'is-color-red';
                case 'gehl':
                    return 'is-color-yellow';
                default:
                    return 'is-color-red';
            }
        },
        brandBackgroundColor(){
            switch(this.$store.state.settings.brand){
                case 'mustang':
                    return 'is-background-color-orange';
                case 'manitou':
                    return 'is-background-color-red';
                case 'gehl':
                    return 'is-background-color-yellow';
                default:
                    return 'is-background-color-red';
            }
        },
        lightboxVideoWidth() {
            return window.innerWidth*0.8;
        },
        lightboxVideoHeight() {
            return window.innerHeight*0.8;
        },
    },
    methods: {
        startLoading(message = null) {
            this.$bus.$emit('loading', true);
            if(message)
                this.$bus.$emit('loadingMessage', message);
        },
        stopLoading() {
            this.$bus.$emit('loading', false);
        },
        enableBlur() {
            this.$bus.$emit('blurMediaBox', true);
        },
        isArray(value) {
            return _.isArray(value)
        },
        returnPreviousPage() {
            window.history.back();
        },
        returnToTop() {
            window.scrollTo(0,0);
        },
        toggle(data){
            this[data] = !this[data]
        },
        getMetricLabel(metricCode){
            switch (metricCode) {
                case 'METER':
                    return {
                        short: 'm',
                        long: 'mètres'
                    }
                case 'KILOGRAM':
                    return {
                        short: 'Kg',
                        long: 'Kilos'
                    }
                default:
                    return {
                        short: '',
                        long: ''
                    }
            }
        },
        slideChanged(payload) {
            this.currentSlide = payload.currentSlide;
        },
        imageSrc(src) {
            try {
                return require(`@/assets/img/`+src);
            } catch (e) {
                return require(`@/assets/img/no_image_available.jpg`);
            }
        },
        slugifyName(datas) {
            const name = ( datas.name || datas.label || datas.values.name || datas.values.reference_name || datas.values.attachment_name || datas.values.service_name);
            return (name ? slugify(name).toUpperCase() : 'no_name')
        },
        async fetchMainVisual(){
            if(this.productDatas.values.main_visual !== undefined) {
                this.pictures.push({
                    type: 'picture',
                    isAsset: false,
                    orientation: 'portrait',
                    src: this.productDatas.values.main_visual.large,
                    thumb: this.productDatas.values.main_visual.medium,

                })
            }
        },
        async fetchShowroomMedias(mediasAttribute){
            //const attributes=this.productDatas.values[mediasAttribute]
            let assets = []
            this.productDatas.assets.forEach((asset)=>
                {
                    if(asset.attribute===mediasAttribute) assets.push(asset)
                }
            )
            if(assets.length>0){
                assets.forEach((asset) => {
                    this.pictures.push({
                        type: 'picture',
                        isAsset: false,
                        orientation: 'landscape',
                        thumb: asset.links.urlsset['no-locale'].medium,
                        src: asset.links.urlsset['no-locale'].large,
                        markets :  asset.markets

                    })
                })
            }
        },
        displayFilterTitle(filter){
            let convertType = [
                'AWP_subcategory',
                'CL_subcategory',
                'MFT_subcategory',
                'MLA_subcategory',
                'MRT_subcategory',
                'MT_subcategory',
                'TMF_subcategory',
                'warehousing_subcategory'
            ]

            if(convertType.includes(filter.attribute))
                return this.$t('type');
            return filter.title;
        },
    }
};

export default mixins;
